export default function SkillsLearned() {
  const skills = [
    {
      category: 'Типы вопросов',
      icon: 'ri-question-answer-line',
      items: [
        { name: 'Открытые вопросы', desc: 'Как разговорить клиента и получить развёрнутую информацию вместо односложных ответов' },
        { name: 'Закрытые вопросы', desc: 'Когда и как использовать закрытые вопросы для подтверждения и уточнения' },
        { name: 'Уточняющие вопросы', desc: 'Техника углубления: от общего запроса к конкретным деталям потребности' },
      ],
    },
    {
      category: 'Методика SPIN',
      icon: 'ri-spy-line',
      items: [
        { name: 'Ситуационные вопросы', desc: 'Сбор контекста: как клиент работает сейчас, какие процессы и инструменты использует' },
        { name: 'Проблемные вопросы', desc: 'Выявление трудностей и неудовлетворённостей текущей ситуацией клиента' },
        { name: 'Извлекающие вопросы', desc: 'Усиление проблемы: какие последствия несёт текущая ситуация для бизнеса клиента' },
        { name: 'Направляющие вопросы', desc: 'Подведение клиента к осознанию ценности вашего решения' },
      ],
    },
    {
      category: 'Активное слушание',
      icon: 'ri-user-voice-line',
      items: [
        { name: 'Перефразирование', desc: 'Как повторить мысль клиента своими словами, чтобы подтвердить понимание' },
        { name: 'Резюмирование', desc: 'Подведение итогов разговора: фиксация ключевых потребностей перед презентацией' },
      ],
    },
    {
      category: 'Практические инструменты',
      icon: 'ri-tools-line',
      items: [
        { name: 'Поиск истинной потребности', desc: 'Отделение симптомов от причин: что клиенту нужно на самом деле' },
        { name: 'Работа с несколькими ЛПР', desc: 'Выявление потребностей на разных уровнях: пользователь, влиятельное лицо, тот кто принимает решение' },
        { name: 'Определение критериев выбора', desc: 'По каким параметрам клиент сравнивает решения и как на это влиять' },
        { name: 'Определение бюджета', desc: 'Как корректно выяснить финансовые возможности без потери доверия' },
        { name: 'Определение срочности', desc: 'Понимание временных рамок и факторов, ускоряющих принятие решения' },
        { name: 'Определение рисков клиента', desc: 'Какие опасения есть у клиента и как их снять через вопросы' },
      ],
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Чему учатся участники
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Программа охватывает все ключевые инструменты диагностики: от базовых типов вопросов до продвинутых техник активного слушания и работы со сложными клиентами.
          </p>
        </div>

        <div className="space-y-10">
          {skills.map((block, i) => (
            <div key={i}>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${block.icon} text-white text-lg`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">{block.category}</h3>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {block.items.map((item, j) => (
                  <div key={j} className="bg-gray-50 rounded-xl p-5 md:p-6 hover:bg-teal-50/50 transition-colors group border border-transparent hover:border-teal-100">
                    <h4 className="text-base font-semibold text-gray-900 mb-2">{item.name}</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}